#import '../../../../shared/graphql/fragments/lead-step-fragment.graphql'

mutation DelayStepForLead($input: StepDelayInput!) {
    stepDelay(input: $input) {
        step {
            ...LeadStepFragment
        }
    }
}
